import GTM from '../../../../helpers/GTM'

interface Item {
  product: {
    productId: string; 
  }
}

const trackUpdateItemQuantity = (data: any, updatedItem: any): void => {

  if (!updatedItem && updatedItem[0]?.product?.productId) {
    return 
  }
  const selectedItem = updatedItem[0]?.product?.productId
  
  const item = data.items.find((item: Item) => item.product.productId === selectedItem)
  const { updateItemQuantityFromCart } = GTM  
  if (item) {
    updateItemQuantityFromCart(item)
  }
  
}

export default trackUpdateItemQuantity
